import Menu from '@components/v2/ui/Menu/Menu';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { RowAction } from './VirtualizedTable.types';

interface ItemMenuProps {
  actions: RowAction[];
  anchorEl: null | HTMLElement;
  onClose: () => void;
  isOpen: boolean;
}

const ItemMenu = ({ actions, anchorEl, onClose, isOpen }: ItemMenuProps) => {
  const { translate } = useTranslation();

  const handleClick = (action: RowAction) => {
    onClose();
    action.onClick();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {!actions.length ? (
        <MenuItem>{translate(LangEnum.GLOBAL_NO_ACTION_AVAILABLE_IN_THIS_STATUS)}</MenuItem>
      ) : (
        actions.map((action) => (
          <MenuItem key={action.label} testId={action.testId} onClick={() => handleClick(action)}>
            <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5 }}>
              {action.icon}
              {translate(action.label)}
            </Stack>
          </MenuItem>
        ))
      )}
    </Menu>
  );
};

export default ItemMenu;
